import { useToolAccess } from '../hooks/useToolAccess'

/** Bulk Media (ADR 0025/0031): open once the Tool is launched for this login and it holds
 *  `access_bulk_media` on at least one Account. The backend answers both
 *  (GET /auth/me/tools) and enforces the same, per Account, on every call.
 *  null while the answer is loading. */
export function useBulkMediaAccess(): boolean | null {
  const tools = useToolAccess()
  return tools ? tools.usable.bulk_media : null
}
